/**
 * Do not edit directly
 * Generated on Fri, 17 Mar 2023 04:59:02 GMT
 */
export const BorderLight = "1px solid #a4b1b8";
export const BorderDark = "1px solid #8a97a0";
export const BorderThickS = "1px";
export const BorderThickM = "2px";
export const BorderThickL = "4px";
export const BorderRadiusNone = "0px";
export const BorderRadiusS = "3px";
export const BorderRadiusM = "4px";
export const BorderRadiusL = "8px";
